// This file is auto-generated by the `scripts/wallets/generate.ts` script.
// Do not modify this file manually.
export const wallet = {
    id: "finance.slingshot",
    name: "Slingshot Wallet",
    homepage: "https://slingshot.finance/",
    image_id: "10c75467-6612-48ad-b97b-63985e922200",
    app: {
        browser: null,
        ios: "https://apps.apple.com/app/apple-store/id1633406472",
        android: "https://play.google.com/store/apps/details?id=com.slingshot.finance",
        mac: "",
        windows: null,
        linux: null,
        chrome: null,
        firefox: null,
        safari: null,
        edge: null,
        opera: null,
    },
    rdns: null,
    mobile: {
        native: "slingshot://",
        universal: "https://app.slingshot.finance",
    },
    desktop: {
        native: null,
        universal: null,
    },
};
//# sourceMappingURL=index.js.map